import { SET_BREADCRUMB_LABEL, RESET_BREADCRUMB_LABELS } from "./types";

export const setBreadcrumbLabel = (path, label) => ({
  type: SET_BREADCRUMB_LABEL,
  payload: {
    path,
    label,
  },
});

export const resetBreadcrumbLabels = () => ({
  type: RESET_BREADCRUMB_LABELS,
});
